import { ChangeDetectionStrategy, Component, Input, ViewChild } from '@angular/core';
import { ButtonV3Component } from '@gea/digital-ui-lib';
import { Popover } from 'primeng/popover';
import { ResolvedMenuOption } from '../data-maintenance.model';

/**
 * Dumb/presentational component that renders the "Publish Workspace" button and its options
 * popover (e.g. Publish updates / Reset workspace). Each option carries its own `action`
 * callback (bound by the parent), this component only decides whether the popover/options
 * are enabled and dispatches the click.
 */
@Component({
  selector: 'app-workspace-options-popover',
  imports: [ButtonV3Component, Popover],
  templateUrl: './workspace-options-popover.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WorkspaceOptionsPopoverComponent {
  @Input() options: ResolvedMenuOption[] = [];
  /** Disables the "Publish Workspace" trigger button itself. */
  @Input() buttonDisabled = false;
  /** Disables the individual options within the opened popover. */
  @Input() itemsDisabled = false;
  /** Number of uncommitted changes in the workspace. */
  @Input() uncommittedCount = 0;

  @ViewChild('workspaceOptionsRef') private popoverRef!: Popover;

  toggle(event: Event): void {
    this.popoverRef.toggle(event);
  }

  onOptionClick(option: ResolvedMenuOption): void {
    if (this.itemsDisabled) return;
    this.popoverRef.hide();
    option.action();
  }
}
